export var colors = {
    primary: '#00F0AA',
    primaryAlt: '#59bfa5',
    primaryAltTransparent: 'rgba(88, 199, 171, 0.51)',
    danger: '#EB5757',
    warning: '#F2994A',
    warning10: '#F2994A1A',
    action: '#07285B',
    smoke: '#979797',
    charcoal: '#353535',
    unSelected: '#E9E9E9',
    secondaryBackground: '#07285B',
    secondaryBackgroundAlt: '#395a71',
    onSecondaryBackgroundAlt: '#627989',
    onSecondaryBackground: '#FFFFFF',
    appexFontColor: '#07285b',
    appexFontDefault: '#1F1F1C',
    white: '#ffffff',
    defaultGreen: '#00F0AA',
    active: '#252525',
    inActive: '#C2C2C2',
    successBtn: '#27ae60',
    btnHover: '#f4f8fa',
    successBtnHover: '#f4fbf7',
    dark: '#000000',
    selected: '#828282',
    muted: '#828282',
    ios: '#828282',
    web: '#7F4AFF',
    android: '#36E0B7',
    selectedOption: '#F5F5F5',
};
